/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import AdvImg from '@components/AdvImg'
import { SportTalkPreviewBtn } from '@views/Matchup/MatchField/PreMatchPage/index.style'
import { MATCH_INSIGHT_TYPE, SPORT_ISSUE_TYPE } from '@v2/constants/sport-issue'
import popularSearchSlideImg from '@assets/images/bg/sport-issue-popular-search-slide.jpg'
import { YouTubeEmbed } from 'react-social-media-embed'
import { Schema$SportIssue } from '@interface/sport-issue'

interface SportTalkPreviewProps {
  sportIssue: Schema$SportIssue
  onClick: () => void,
  isGray?: boolean,
}

const SportTalkIssuePreview: React.FC<SportTalkPreviewProps> = observer((props) => {
  const { sportIssue, onClick, isGray } = props
  const { sportIssueType, content } = sportIssue

  if (
    sportIssueType === SPORT_ISSUE_TYPE.MATCH_INSIGHT &&
    sportIssue.matchInsight?.matchInsightType === MATCH_INSIGHT_TYPE.TIMELINE
  ) {
    return null
  }

  let previewElem: JSX.Element
  let previewTxt: string

  if (sportIssueType === SPORT_ISSUE_TYPE.POPULAR_SEARCH_TERM_NEWS){
    previewElem = <AdvImg srcMode={'small'}
                          src={popularSearchSlideImg}
                          alt="now 이슈키워드"
                          className="preview-img"
                          loading={'lazy'}/>
    previewTxt = content
  } else if (sportIssueType === SPORT_ISSUE_TYPE.MATCH_INSIGHT){
    const { matchInsightType, attachment } = sportIssue.matchInsight
    if (matchInsightType === MATCH_INSIGHT_TYPE.IMAGE){
      previewElem = <AdvImg srcMode={'small'}
                            src={attachment}
                            alt="now 이슈키워드"
                            className="preview-img"
                            loading={'lazy'}/>
      previewTxt = content
    } else if (matchInsightType === MATCH_INSIGHT_TYPE.URL) {
      previewElem = (<div className="preview-img iframe">
        <YouTubeEmbed url={attachment} width={'240px'} height={'136px'} className="preview-img"/>
      </div>)
      previewTxt = content
    }
  }


  return (
    <SportTalkPreviewBtn onClick={onClick} className={isGray && 'is-gray'}>
      {previewElem}
      <p className="sport-talk-contents info">{previewTxt}</p>
    </SportTalkPreviewBtn>
  )

})
export default SportTalkIssuePreview
